<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFP">
     CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_th" title="ข้อมูลเพื่อความปลอดภัย">
     ข้อมูลเพื่อความปลอดภัย
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="คำอธิบายสัญลักษณ์">
      คำอธิบายสัญลักษณ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="คำประกาศเกี่ยวกับผลิตภัณฑ์">
      คำประกาศเกี่ยวกับผลิตภัณฑ์
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_th" title="เรียนรู้เกี่ยวกับเครื่องพิมพ์">
     เรียนรู้เกี่ยวกับเครื่องพิมพ์
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_th" title="การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์">
      การค้นหาข้อมูลเกี่ยวกับเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_th" title="การค้นหาหมายเลขประจำเครื่องของเครื่องพิมพ์">
      การค้นหาหมายเลขประจำเครื่องของเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_th" title="การกำหนดค่าเครื่องพิมพ์">
      การกำหนดค่าเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_th" title="การใช้แผงควบคุม">
      การใช้แผงควบคุม
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_th" title="ไอคอนหน้าจอหลัก">
      ไอคอนหน้าจอหลัก
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_th" title="สีของไฟแสดงสถานะ">
      สีของไฟแสดงสถานะ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_th" title="การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์">
      การใช้ตัวป้อนกระดาษอัตโนมัติและกระจกสแกนเนอร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_th" title="การค้นหาช่องสำหรับความปลอดภัย">
      การค้นหาช่องสำหรับความปลอดภัย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="การเลือกกระดาษ">
      การเลือกกระดาษ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10650" title="คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์">
      คุณสมบัติและการสนับสนุนเพิ่มเติมของเครื่องพิมพ์
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_th" title="ตั้งค่า ติดตั้ง และกำหนดค่า">
     ตั้งค่า ติดตั้ง และกำหนดค่า
    </a>
   </p>
   <div id="divd0e10777">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_th" title="การเลือกตำแหน่งสำหรับเครื่องพิมพ์">
      การเลือกตำแหน่งสำหรับเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_th" title="พอร์ตเครื่องพิมพ์">
      พอร์ตเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10976" title="การกำหนดค่าแอปและโซลูชัน">
      การกำหนดค่าแอปและโซลูชัน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11153" title="การตั้งค่าและการใช้คุณสมบัติการเข้าถึง">
      การตั้งค่าและการใช้คุณสมบัติการเข้าถึง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11458" title="การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์">
      การตั้งค่าเครื่องพิมพ์เพื่อรับ-ส่งแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_th" title="การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ">
      การป้อนกระดาษและวัสดุพิมพ์ชนิดพิเศษ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12254" title="การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์">
      การติดตั้งและการอัปเดตซอฟต์แวร์ ไดรเวอร์ และเฟิร์มแวร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12580" title="การติดตั้งตัวเลือกฮาร์ดแวร์">
      การติดตั้งตัวเลือกฮาร์ดแวร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14111" title="การเชื่อมต่อเครือข่าย">
      การเชื่อมต่อเครือข่าย
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_th" title="รักษาความปลอดภัยของเครื่องพิมพ์">
     รักษาความปลอดภัยของเครื่องพิมพ์
    </a>
   </p>
   <div id="divd0e14463">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_th" title="การลบหน่วยความจำเครื่องพิมพ์">
      การลบหน่วยความจำเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_th" title="การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์">
      การลบไดรฟ์จัดเก็บข้อมูลของเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_th" title="การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน">
      การคืนค่าการตั้งค่าเริ่มต้นจากโรงงาน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_th" title="คำประกาศเกี่ยวกับความถาวรของข้อมูล">
      คำประกาศเกี่ยวกับความถาวรของข้อมูล
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_th" title="พิมพ์">
     พิมพ์
    </a>
   </p>
   <div id="divd0e14655">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_th" title="การพิมพ์จากคอมพิวเตอร์">
      การพิมพ์จากคอมพิวเตอร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14706" title="การพิมพ์จากอุปกรณ์มือถือ">
      การพิมพ์จากอุปกรณ์มือถือ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_th" title="การพิมพ์จากแฟลชไดรฟ์">
      การพิมพ์จากแฟลชไดรฟ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_th" title="การกำหนดค่างานลับ">
      การกำหนดค่างานลับ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_th" title="การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ">
      การพิมพ์งานที่เป็นความลับและงานที่ระงับไว้อื่นๆ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_th" title="การพิมพ์รายการตัวอย่างฟอนต์">
      การพิมพ์รายการตัวอย่างฟอนต์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_th" title="การพิมพ์รายการไดเรกทอรี่">
      การพิมพ์รายการไดเรกทอรี่
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_th" title="การใส่แผ่นคั่นในงานพิมพ์">
      การใส่แผ่นคั่นในงานพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_th" title="การยกเลิกงานพิมพ์">
      การยกเลิกงานพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_th" title="การปรับความเข้มของหมึก">
      การปรับความเข้มของหมึก
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_th" title="ทำสำเนา">
     ทำสำเนา
    </a>
   </p>
   <div id="divd0e15201">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_th" title="การทำสำเนา">
      การทำสำเนา
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_th" title="การทำสำเนาภาพถ่าย">
      การทำสำเนาภาพถ่าย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_th" title="การทำสำเนาบนกระดาษหัวจดหมาย">
      การทำสำเนาบนกระดาษหัวจดหมาย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_th" title="การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน">
      การทำสำเนาลงบนหน้ากระดาษทั้งสองด้าน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_th" title="การย่อหรือขยายขนาดสำเนา">
      การย่อหรือขยายขนาดสำเนา
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_th" title="การเรียงหน้าสำเนา">
      การเรียงหน้าสำเนา
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_th" title="การใส่แผ่นคั่นระหว่างสำเนา">
      การใส่แผ่นคั่นระหว่างสำเนา
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_th" title="การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว">
      การทำสำเนาเอกสารหลายหน้าลงบนกระดาษแผ่นเดียว
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_th" title="การสำเนาบัตร">
      การสำเนาบัตร
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_th" title="การสร้างทางลัดสำเนา">
      การสร้างทางลัดสำเนา
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_th" title="อีเมล">
     อีเมล
    </a>
   </p>
   <div id="divd0e15474">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_th" title="การกำหนดค่าการตั้งค่า SMTP">
      การกำหนดค่าการตั้งค่า SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_th" title="การส่งอีเมล">
      การส่งอีเมล
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_th" title="การสร้างทางลัดอีเมล">
      การสร้างทางลัดอีเมล
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_th" title="แฟกซ์">
     แฟกซ์
    </a>
   </p>
   <div id="divd0e16923">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_th" title="การส่งแฟกซ์">
      การส่งแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_th" title="การกำหนดเวลาการแฟกซ์">
      การกำหนดเวลาการแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_th" title="การสร้างทางลัดปลายทางแฟกซ์">
      การสร้างทางลัดปลายทางแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_th" title="การเปลี่ยนความละเอียดของแฟกซ์">
      การเปลี่ยนความละเอียดของแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_th" title="การปรับความเข้มของแฟกซ์">
      การปรับความเข้มของแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_th" title="การพิมพ์บันทึกการแฟกซ์">
      การพิมพ์บันทึกการแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_th" title="การปิดกั้นแฟกซ์ที่ไม่ต้องการ">
      การปิดกั้นแฟกซ์ที่ไม่ต้องการ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_th" title="การระงับแฟกซ์">
      การระงับแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_th" title="การส่งต่อแฟกซ์">
      การส่งต่อแฟกซ์
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_th" title="สแกน">
     สแกน
    </a>
   </p>
   <div id="divd0e17219">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_th" title="การสแกนไปยังคอมพิวเตอร์">
      การสแกนไปยังคอมพิวเตอร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_th" title="การสแกนไปยังเซิร์ฟเวอร์ FTP">
      การสแกนไปยังเซิร์ฟเวอร์ FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_th" title="การสร้างทางลัด FTP">
      การสร้างทางลัด FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_th" title="การสแกนไปยังโฟลเดอร์เครือข่าย">
      การสแกนไปยังโฟลเดอร์เครือข่าย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_th" title="การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย">
      การกำหนดค่าปลายทางโฟลเดอร์เครือข่าย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_th" title="การสร้างทางลัดโฟลเดอร์เครือข่าย">
      การสร้างทางลัดโฟลเดอร์เครือข่าย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_th" title="การสแกนไปยังแฟลชไดร์ฟ">
      การสแกนไปยังแฟลชไดร์ฟ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_th" title="เมนูเครื่องพิมพ์">
     เมนูเครื่องพิมพ์
    </a>
   </p>
   <div id="divd0e17508">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_th" title="ผังเมนู">
      ผังเมนู
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17822" title="อุปกรณ์">
      อุปกรณ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20056" title="พิมพ์">
      พิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21338" title="กระดาษ">
      กระดาษ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21670" title="ทำสำเนา">
      ทำสำเนา
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22229" title="แฟกซ์">
      แฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24096" title="อีเมล">
      อีเมล
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25193" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25899" title="ไดรฟ์ USB">
      ไดรฟ์ USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26745" title="เครือข่าย/พอร์ต">
      เครือข่าย/พอร์ต
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28896" title="การรักษาความปลอดภัย">
      การรักษาความปลอดภัย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29993" title="บริการระบบคลาวด์">
      บริการระบบคลาวด์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30050" title="รายงาน">
      รายงาน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_th" title="การแก้ไขปัญหา">
      <strong>
       การแก้ไขปัญหา
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_th" title="Forms Merge">
      <strong>
       Forms Merge
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_th" title="การพิมพ์ หน้าการตั้งค่าเมนู">
      การพิมพ์
      <strong>
       หน้าการตั้งค่าเมนู
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_th" title="ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์">
     ตัวเลือกอุปกรณ์เย็บเล่มของเครื่องพิมพ์
    </a>
   </p>
   <div id="divd0e30533">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_th" title="การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ">
      การใช้อุปกรณ์เย็บเล่มแบบใช้ลวดเย็บ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_th" title="การใช้อุปกรณ์เย็บเล่มตอกรู">
      การใช้อุปกรณ์เย็บเล่มตอกรู
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_th" title="การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต">
      การใช้อุปกรณ์เรียงกระดาษออฟเซ็ต
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_th" title="การใช้อุปกรณ์เย็บเล่ม">
      การใช้อุปกรณ์เย็บเล่ม
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_th" title="การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ">
      การใช้อุปกรณ์ส่งกระดาษที่มีตัวเลือกการพับ
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_th" title="ดูแลรักษาเครื่องพิมพ์">
     ดูแลรักษาเครื่องพิมพ์
    </a>
   </p>
   <div id="divd0e30943">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_th" title="การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง">
      การตรวจสอบสถานะของชิ้นส่วนและวัสดุสิ้นเปลือง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_th" title="การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง">
      การกำหนดค่าการแจ้งเตือนวัสดุสิ้นเปลือง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_th" title="การตั้งค่าการแจ้งเตือนทางอีเมล">
      การตั้งค่าการแจ้งเตือนทางอีเมล
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_th" title="การสร้างรายงานและบันทึก">
      การสร้างรายงานและบันทึก
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_th" title="การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง">
      การสั่งซื้อชิ้นส่วนและวัสดุสิ้นเปลือง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31798" title="การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง">
      การเปลี่ยนชิ้นส่วนและวัสดุสิ้นเปลือง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32422" title="การทำความสะอาดชิ้นส่วนเครื่องพิมพ์">
      การทำความสะอาดชิ้นส่วนเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32586" title="การประหยัดพลังงานและกระดาษ">
      การประหยัดพลังงานและกระดาษ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_th" title="การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น">
      การย้ายเครื่องพิมพ์ไปยังตำแหน่งอื่น
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_th" title="การแก้ไขปัญหา">
     การแก้ไขปัญหา
    </a>
   </p>
   <div id="divd0e32724">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_th" title="ปัญหาคุณภาพการพิมพ์">
      ปัญหาคุณภาพการพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_th" title="รหัสข้อผิดพลาดของเครื่องพิมพ์">
      รหัสข้อผิดพลาดของเครื่องพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_th" title="ปัญหาเกี่ยวกับการพิมพ์">
      ปัญหาเกี่ยวกับการพิมพ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_th" title="เครื่องพิมพ์ไม่ตอบสนอง">
      เครื่องพิมพ์ไม่ตอบสนอง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_th" title="ไม่สามารถอ่านแฟลชไดรฟ์ได้">
      ไม่สามารถอ่านแฟลชไดรฟ์ได้
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_th" title="การเปิดใช้งานพอร์ต USB">
      การเปิดใช้งานพอร์ต USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_th" title="การแก้ไขกระดาษติด">
      การแก้ไขกระดาษติด
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36148" title="ปัญหาการเชื่อมต่อเครือข่าย">
      ปัญหาการเชื่อมต่อเครือข่าย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36241" title="ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์">
      ปัญหาเกี่ยวกับตัวเลือกฮาร์ดแวร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36414" title="ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง">
      ปัญหาเกี่ยวกับวัสดุสิ้นเปลือง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36562" title="ปัญหาเกี่ยวกับการป้อนกระดาษ">
      ปัญหาเกี่ยวกับการป้อนกระดาษ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36756" title="ปัญหาการรับส่งอีเมล">
      ปัญหาการรับส่งอีเมล
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36811" title="ปัญหาการแฟกซ์">
      ปัญหาการแฟกซ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37133" title="ปัญหาการสแกน">
      ปัญหาการสแกน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37551" title="ปัญหาคุณภาพสี">
      ปัญหาคุณภาพสี
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_th" title="การติดต่อฝ่ายให้คำปรึกษาลูกค้า">
      การติดต่อฝ่ายให้คำปรึกษาลูกค้า
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_th" title="รีไซเคิลและกำจัด">
     รีไซเคิลและกำจัด
    </a>
   </p>
   <div id="divd0e37777">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_th" title="การรีไซเคิลผลิตภัณฑ์ Lexmark">
      การรีไซเคิลผลิตภัณฑ์ Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_th" title="การรีไซเคิลบรรจุภัณฑ์ Lexmark">
      การรีไซเคิลบรรจุภัณฑ์ Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_th" title="คำประกาศ">
     คำประกาศ
    </a>
   </p>
   <div id="divd0e37813">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37816" title="ข้อมูลผลิตภัณฑ์">
      ข้อมูลผลิตภัณฑ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37833" title="หมายเหตุการปรับปรุง">
      หมายเหตุการปรับปรุง
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_th" title="เครื่องหมายการค้า">
      เครื่องหมายการค้า
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_th" title="คำประกาศเรื่องการอนุญาต">
      คำประกาศเรื่องการอนุญาต
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_th" title="ระดับการปล่อยเสียงรบกวน">
      ระดับการปล่อยเสียงรบกวน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37931" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_th" title="การทิ้งผลิตภัณฑ์">
      การทิ้งผลิตภัณฑ์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_th" title="การแจ้งเตือนความไวต่อไฟฟ้าสถิต">
      การแจ้งเตือนความไวต่อไฟฟ้าสถิต
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_th" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_th" title="ข้อมูลเกี่ยวกับอุณหภูมิ">
      ข้อมูลเกี่ยวกับอุณหภูมิ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_th" title="ประกาศเรื่องเลเซอร์">
      ประกาศเรื่องเลเซอร์
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_th" title="การใช้พลังงาน">
      การใช้พลังงาน
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38175" title="Thailand NBTC technical standards conformity statementคำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย">
      Thailand NBTC technical standards conformity statement
      <br/>
      คำประกาศเรื่องการเป็นไปตามมาตรฐานทางเทคนิคของ กสทช. ประเทศไทย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38182" title="คำประกาศควบคุมสำหรับผลิตภัณฑ์ไร้สาย">
      คำประกาศควบคุมสำหรับผลิตภัณฑ์ไร้สาย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_th" title="ประกาศเกี่ยวกับชิ้นส่วนแบบแยก">
      ประกาศเกี่ยวกับชิ้นส่วนแบบแยก
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_th" title="การแผ่รังสีความถี่คลื่นวิทยุ">
      การแผ่รังสีความถี่คลื่นวิทยุ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38208" title="Notice to users in Thailandประกาศถึงผู้ใช้ในประเทศไทย">
      Notice to users in Thailand
      <br/>
      ประกาศถึงผู้ใช้ในประเทศไทย
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_th" title="คำประกาศคลื่นวิทยุรบกวน">
      คำประกาศคลื่นวิทยุรบกวน
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue